import React from "react";
import "./Switch.scss";
import { ISwitchProps } from "../../../interfaces/Index";

const Switch: React.FunctionComponent<ISwitchProps> = (props) => {
  return (
    <div className="switch-container">
      <label className="label block">{props.label}</label>
      <label className="switch">
        <input
          name={props.name}
          type="checkbox"
          id={props.id}
          checked={props.checked}
          onChange={props.handleSwitch}
          value={props.value}
          disabled={props.disabled}
        />
        <span className="slider"></span>
      </label>
      <label className="switch-status">
        {props.checked ? props.statusVal1 : props.statusVal2}
      </label>
    </div>
  );
};

Switch.defaultProps = {
  label: "switch label",
  id: "switchID",
  checked: false,
  statusVal1: "Enabled",
  statusVal2: "Disabled",
  disabled: false,
};

export default Switch;
